import { DealSelectionReducer } from "@snackpass/accounting";

export const getDealSelection = (state: {
    dealSelection: DealSelectionReducer;
}) => state.dealSelection;
